module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.7b5f76c3.jpg";